import { useNavigation } from "react-router-dom";
import { ProgressBar as BootstrapProgressBar } from "react-bootstrap";

export function ProgressBar() {
  const navigation = useNavigation();
  const showGlobalPendingUI = navigation.state === "loading";

  return (
    <BootstrapProgressBar
      now={showGlobalPendingUI ? 100 : 0}
      min={0}
      max={100}
    />
  );
}
